// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nwUgQGDhmA4ZiTmM{padding:4px;border-radius:4px;cursor:default}.nwUgQGDhmA4ZiTmM.SHCdLg8XWgT9Yl5V{background-color:var(--py-green-1);color:var(--py-green-6)}.nwUgQGDhmA4ZiTmM.Y19fPj7CLJA_MCE4{background-color:var(--py-red-1);color:var(--py-red-6)}.nwUgQGDhmA4ZiTmM.SDG1JZvJSDgEPnEv{background-color:var(--py-primary-1);color:var(--py-primary-6)}.nwUgQGDhmA4ZiTmM .c6jn5FiRhBkJzPOd{display:flex;align-items:center;justify-content:center;gap:4px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"indicator": `nwUgQGDhmA4ZiTmM`,
	"positive": `SHCdLg8XWgT9Yl5V`,
	"negative": `Y19fPj7CLJA_MCE4`,
	"zero": `SDG1JZvJSDgEPnEv`,
	"row": `c6jn5FiRhBkJzPOd`
};
export default ___CSS_LOADER_EXPORT___;
